import type { TalkActions } from "@mgdx/talk/stores/talkStore";
import { clearAccessToken } from "@mgdx-libs/firebase";

import { clearServerState } from "../../queryClient";
import { clearCurrentUser } from "../../stores/currentUserStore";
import { integratedCounselingStore } from "../../stores/integratedCounselingStore";
import { talkStore, videoCallingStore } from "../../stores/sharedStores";
import { clearOtcGuidanceSessionStorage } from "../otcGuidance/otcGuidanceSessionStorage";

/**
 * 一括予約の入力(患者 ID・保険証の種類・配送先など)、選択中のトークルーム、通話中の予約を消す。
 * 保存先の storage だけでなくメモリ上の状態も消し、ログアウトや切り替えの後に次の患者へ引き継がない。
 * ログイン前の入力を引き継いでログインする経路(LIFF・LINE 連携など)では呼ばない
 */
export const clearPatientSessionState = () => {
  integratedCounselingStore.getState().actions.resetIntegratedCounseling();
  talkStore.getState().actions.clearTalkState();
  videoCallingStore.getState().actions.closeVideoCalling();
};

export const clearTokenAndState = (disableTalk: TalkActions["disableTalk"]) => {
  disableTalk();
  clearServerState();
  clearCurrentUser();
  clearAccessToken();
  // 認証主体が変わったときに、要指導の戻り先や予約 ID を次の患者へ引き継がない
  clearOtcGuidanceSessionStorage();
};
